import { Notes } from './notes.model';

export class ICTProjectHistory {
    constructor() {
        this.version = 0;
    }
    id: string;
    projectName: string;
    contactPerson: string;
    companyName: string;
    contentType: string;
    changesAllowed: boolean;
    restrictedContent: boolean;
    description: string;
    tags: Array<string>;
    purposeOfUsage: string;
    fileName: string;
    fileURL: string;
    clientLogo: string;
    createdBy: string;
    createdOn: any;
    updatedOn: any;
    updatedBy: string;
    organizationId: string;
    organizationName: string;
    notes: Array<Notes>;
    approvedBy: string;
    projectId: string;
    isLocked: boolean;
    version: number;
    isDeleted: boolean;
}
